export default {
    patentReview: {
        documentPane: {
            page: 'Page {current} of {total}',
            previousPage: 'Previous page',
            nextPage: 'Next page',
            'document': 'Document under review',
            'readOnly': 'Read only',
            'localFile': 'Local Preview',
            'original': 'Original Document',
            'text': 'Extracted Text',
            'textHint': 'Extracted text supports verification and location; original formatting is not preserved.',
            'zoomIn': 'Zoom in',
            'zoomOut': 'Zoom out',
            'loading': 'Loading document…',
            'unsupported': 'Original preview is not supported for this format. Use extracted text. Word preview supports DOCX.',
            'failed': 'Could not load the original file. Retry or view extracted text.',
            'noFile': 'No original file is available. Choose a local Word / PDF for browser-only preview; it will not be uploaded or replace task files.',
            'retry': 'Retry',
            'unresolved': 'An exact location is unavailable. Compare the finding with the source text.',
            'missingInsertion': 'Add the missing content here',
            'empty': 'No extracted content yet',
        },
        results: {
            'results': 'Review results',
            'sort': 'Sort results',
            'importance': 'By importance',
            'document': 'By document order',
            'figureOrder': 'By position in drawing',
            'passed': 'Passed',
            'failed': 'Failed',
            'manual': 'Manual review',
            'ignore': 'Ignore',
            'confirm': 'Confirm',
            'ignored': 'Ignored',
            'confirmed': 'Confirmed',
            'summary': 'Review result summary',
            'ruleName': 'Rule name',
            'unnamedRule': 'Unnamed rule',
            'expand': 'Expand',
            'collapse': 'Collapse',
            'status': 'Status',
            'rule': 'Review rule',
            'reason': 'Reason for failure',
            'explanation': 'Result explanation',
            'suggestion': 'Suggested changes',
            'location': 'Location',
            'system': 'System rule',
            'custom': 'Custom rule',
            'ruleUnavailable': 'Rule text unavailable',
            'locationUnavailable': 'Source location unavailable',
            'orderHint': 'Sorted by parsed section and source position. Items without a position retain section order.',
            'figureOrderHint': 'Sorted by position in the selected drawing. Items without a position retain check order.',
        },
        figurePane: {
            combinedReview: 'Drawing review', abstractDrawing: 'Abstract drawing',
            workspace: 'Drawing comparison workspace', readOnly: 'Read only', recognizedCount: '{count} drawing images identified',
            figure_overview: 'Drawing-by-Drawing Review', figure_completeness: 'Drawing completeness', figure_compliance: 'Drawing format', figure_consistency: 'Drawing-text consistency', abstract_drawing: 'Abstract drawing',
            matrixTitle: 'Drawing-by-drawing review status', drawing: 'Drawing', presenceCheck: 'Present', visualCheck: 'Image compliance', claimsCheck: 'Claims consistency', specificationCheck: 'Specification consistency',
            presenceShort: 'Present', visualShort: 'Visual', claimsShort: 'Claims', specificationShort: 'Spec.',
            checkStatus_pass: 'Passed', checkStatus_fail: 'Failed', checkStatus_manual: 'Review', checkStatus_pending: 'Pending', numberNeedsConfirmation: 'Number unconfirmed',
            drawingNavigator: 'Drawing navigator', drawingTotal: '{count} drawings', collapseNavigator: 'Collapse', expandNavigator: 'Expand', drawingRange: 'Drawings {start}–{end}',
            previousDrawing: 'Previous', nextDrawing: 'Next', drawingPosition: '{current} of {total}', drawingReviewTitle: '{drawing} review',
            missingFigure: 'Drawing missing', missingFigureHint: 'Fig. {number} is referenced in the text, but no corresponding image was identified.', abstractCandidates: 'Abstract drawing candidates',
            recognitionUnavailable: 'Drawing recognition is unavailable', recognitionUnavailableHint: 'The presence of drawings cannot be confirmed, so this step is not treated as passed.',
            expectedFigures: 'Expected from text', actualFigures: 'Actually identified', figureNo: 'Fig. {number}', unknownFigure: 'Unknown number · image {number}',
            noFigureNumbers: 'Images were identified, but no reliable figure numbers are available.', noFigures: 'No drawings identified', noFiguresHint: 'Confirm whether this application requires drawings and add the missing file when needed.',
            notFound: 'Not found', unknownCount: '{count} additional images have no identified figure number', inventoryBasis: 'Inventory basis', noDrawingsDescription: 'The brief description of drawings was not identified; the expected inventory may be incomplete.',
            previewPending: 'The current API does not provide a single-image preview', noDescription: 'No image description available', referenceSigns: 'Identified reference signs', noReferenceSigns: 'No reference signs identified',
            drawingsDescription: 'Brief description of drawings', relatedFullText: 'View related full text', noRelatedText: 'No text is available for comparison', abstractText: 'Abstract text', noAbstract: 'The abstract was not identified',
            abstractCandidateHint: 'This version shows candidate drawings beside the abstract. The review result remains the source of the selected abstract drawing.',
            confidence_high: 'High figure-number confidence', confidence_medium: 'Figure number inferred by model', confidence_low: 'Figure number needs confirmation',
            source_caption_regex: 'From source caption', source_vision_match: 'From visual-text matching', source_unknown: 'Unknown number source',
        },
        workflow: {
            incompleteFileTitle: 'The file is incomplete',
            skipMissingNotice: 'The following checks will be skipped: {sections}. Add the missing files for a complete review.',
            fileChecklist: 'File content checklist',
            notRecognized: 'Not detected',
            missingSection: '{section} was not detected and will not be checked in subsequent steps.',
            unconfirmedSection: 'Detection of {section} is not yet confirmed. Check the source and add a file if needed.',
            supplementSection: 'Add file: {section}',
            replaceSupplement: 'Replace file',
            supplementPending: 'Pending submission · This file is held on this page only and has not been added to this review.',
            invalidSupplement: 'Choose a non-empty Word, PDF, TXT or image file.',
            reviewCount: '{count} records to review',
            noConclusion: 'No overall conclusion is available. Review each section.',
            claimsMaterial: 'Claims',
            specificationMaterial: 'Specification',
            'detection': 'File Detection',
            'claims': 'Claims Review',
            'specification': 'Specification Review',
            'figures': 'Drawings Review',
            'report': 'Review Results',
            'title': 'Title',
            'technical_field': 'Technical Field',
            'background': 'Background',
            'summary': 'Summary of Invention',
            'detailed_description': 'Detailed Description',
            'abstract': 'Abstract',
            'drawings': 'Drawings',
            'drawings_description': 'Description of Drawings',
            'figure_overview': 'Drawing-by-Drawing Review',
            'figure_completeness': 'Drawing Completeness',
            'figure_compliance': 'Drawing Format',
            'figure_consistency': 'Drawing-Text Consistency',
            'abstract_drawing': 'Abstract Drawing',
            'unclassified': 'Cross-section / Unclassified',
            'all': 'All Results',
            'waiting': 'Awaiting results',
            'partial': 'Partial results',
            'available': 'Results available',
            'failed': 'Execution interrupted',
            'source': 'Source and Materials',
            'detected': 'Identified',
            'unconfirmed': 'To confirm',
            'detecting': 'Identifying',
            'figureFound': '{count} drawings identified; applicability requires confirmation',
            'figureEmpty': 'No drawings identified; confirm whether they are required',
            'figureUnknown': 'Drawing recognition unavailable; applicability is unknown',
            'optional': 'Optional; not required to start application review',
            'disclosure': 'Technical Disclosure',
            'supplement': 'Complete Materials',
            'supplementHint': 'This task does not support adding materials yet. Return home and upload the complete materials to create a new task.',
            'newTask': 'Return Home to Upload',
            'close': 'Close',
            'reviewHint': 'Results are grouped by document section. More findings may arrive while results are partial.',
            'scopeHint': 'Results without a reliable section are retained below for review.',
            'empty': 'No check records in this scope yet. This does not mean the checks passed.',
            'noSource': 'Source text is not available. Check File Detection.',
            'sourceWhole': 'Full specification text is shown. Use issue locations for individual sections.',
            'confirmDetection': 'Confirm',
            'locate': 'Locate Source',
            'basis': 'Basis',
            'suggestion': 'Suggestion',
            'boundary': 'Applicability',
            'notAssessed': 'Not assessed',
            'pass': 'Passed',
            'issue': 'Review needed',
            'retry': 'Reload Results',
            'loadFailed': 'Could not load results. Please retry.',
            'detectionHint': 'Check material completeness and readability, including drawing applicability. Identified content does not mean checks passed.',
            'pendingApplicability': 'Applicability to confirm',
            'export': 'Export Report',
            'reportPending': 'The report is not ready. You can inspect available section results.',
        },
        entry: {
            materials: 'Review materials',
            applicationReview: 'Patent application',
            description: 'Upload the application to review and add reference materials as needed.',
            required: 'Required',
            optional: 'Optional',
            choose: 'Choose files',
            replace: 'Replace file',
            remove: 'Remove {name}',
            targetLabel: 'Application file',
            targetHint: 'Upload one complete patent application. Word and PDF are supported, including drag and drop.',
            supportingLabel: 'Other technical materials',
            supportingHint: 'Upload multiple files for technical consistency checks. Word, PDF, TXT, JPG and PNG are supported.',
            disclosureLabel: 'Technical disclosure',
            disclosureHint: 'Compare technical content with the application · Word / PDF / TXT',
            otherLabel: 'Other materials',
            otherHint: 'Currently supports drawings · PDF / JPG / PNG',
            unsupportedFormat: 'This file format is not supported for this material.',
            tooManyFiles: 'Select up to 10 files across all material types.',
            oneTarget: 'Select one complete application file.',
            fileCount: '{count}/10 files selected',
            start: 'Start review',
            submitting: 'Submitting…',
            rules: 'Rule Library',
            selectedLibraries: '{office} · {count} libraries',
            libraryHint: 'The system library determines the patent office. Add custom libraries for the same office.',
            taskCreated: 'Review task created',
            ruleDialog: 'Select Rule Library',
            ruleScopeHint: 'Choose one system library and optional custom libraries for the same office. Switching system libraries removes selections for other offices.',
            selectionRequired: 'Select a valid system library and custom libraries for the same office.',
            libraryLoadFailed: 'Could not load libraries. Close and try again.',
        },
        list: {
            title: 'Review Tasks',
            empty: 'No review tasks yet',
            emptyHint: 'Upload a patent draft file to start a formal review',
            rules: 'rules',
            tabTasks: 'Task List',
            tabRules: 'Rule Library',
        },
        status: {
            pending: 'Pending',
            running: 'Running',
            completed: 'Completed',
            failed: 'Failed',
        },
        steps: {
            '1_parsing': 'Parse file',
            '2_extracting': 'Extract elements',
            '3_figure_analysis': 'Figure Analysis',
            '4_formal_check': 'Formal Review',
            '5_finalizing': 'Final Report',
        },
        stepStatus: {
            done: 'Done',
            running: 'Running',
            failed: 'Failed',
            pending: 'Pending',
        },
        upload: {
            customRulesSection: {
                dialogTitle: 'Rule Library',
                searchPlaceholder: 'Search rule library name',
                customGroup: 'Custom Rule Library',
                newGroup: 'Uploaded This Time',
                uploadButton: 'Upload Rules',
                uploadFormats: 'Supports .docx / .pdf / .pptx',
                confirm: 'Confirm Selection',
                confirmSelection: 'Confirm',
                empty: 'No rule libraries yet. Click "Upload Rules" to add one',
                rulesEmpty: 'No rules were extracted from this library',
                loadFailed: 'Failed to load rule libraries, please retry',
                uploadFailed: 'Failed to upload the rule file, please retry',
                tableIndex: 'No.',
                tableSection: 'Review Section',
                tableIssueDesc: 'Issue Description',
            },
            patentType: {
                label: 'Patent Type',
                invention: 'Invention',
                utility: 'Utility Model',
            },
            cancel: 'Cancel',
        },
        detail: {
            backToList: 'Back to list',
            taskHeader: {
                entry: 'Formal Review',
                projectPackage: 'Patent Review Project Package',
                unnamedTask: 'Untitled task',
                progressTitle: 'Review Progress',
                autoRun: 'Auto-run',
                exportReport: 'Export Report',
                exportNotReady: 'Available once the review is complete',
                finalizingCardSubtitle: 'Summary conclusion',
                stepsExecutedCaption: '3 processes executed',
                parsingCaption: 'Parsing…',
                issueCountSuffix: '{count} issues',
            },
            materials: {
                mainFileTag: 'Patent application',
                figureTag: 'Figures',
                disclosureTag: 'Disclosure',
                attachmentTag: 'Attachment',
            },
            parsing: {
                fileName: 'File name',
                fileNamePending: 'Identifying the main file…',
                hint: 'Parsing the uploaded file…',
                inspectionSummary: '{located}/{total} sections located',
                characterCount: '{count} chars',
                locate: 'Locate',
                missing: 'Content not detected',
                documentType: {
                    patent_application: 'Patent application',
                    disclosure: 'Technical disclosure',
                    office_action: 'Office action',
                    unknown: 'Document type to confirm',
                },
            },
            extracting: {
                title: 'Title',
                technical_field: 'Technical Field',
                background: 'Background',
                summary: 'Summary of Invention',
                drawings_description: 'Description of Drawings',
                detailed_description: 'Detailed Description',
                abstract: 'Abstract',
                claims: 'Claims',
                specification: 'Specification',
                figures: 'Figures',
                expand: 'Expand',
                collapse: 'Collapse',
                empty: 'No content',
            },
            check: {
                pass: 'Pass',
                passCollapsed: 'Passed ({count})',
                filterAll: 'All',
                filterInfo: 'Info',
                filterWarning: 'Warning',
                filterError: 'Error',
                filterCritical: 'Critical',
                location: 'Location',
                suggestion: 'Suggestion',
                guidelineSource: 'Guideline source',
                empty: 'No formal check issues',
                summaryPattern: 'Found {count} formal or enterprise-standard issues that can be located',
                statTitle: 'Found {count} formal issues: {officialCount} against official rules, {customCount} against enterprise rules.',
                statFormalIssues: 'Formal issues',
                statOfficialViolations: 'Against official rules',
                statCustomViolations: 'Against enterprise rules',
                summaryTitle: 'Formal Check Summary',
                summaryError: '{count} errors',
                summaryWarning: '{count} non-compliant items',
                summaryRequireConfirm: '{count} items require manual confirmation',
                summaryStats: '{total} total rules · {error} · {warning} · {requireConfirm} items · {pass} items passed',
                systemRules: 'System Rules',
                customRules: 'Enterprise Rules',
                legendPass: 'Passed',
                legendFail: 'Failed',
                legendPending: 'Requires manual confirmation',
                summaryAllPassed: 'All passed',
                coverageTitle: 'Rule coverage',
                coverageSource: 'Rule source',
                coverageTotal: 'Rules',
                coverageFail: 'Failed',
                coverageVerify: 'Needs review',
                coveragePending: 'Pending verification',
                coveragePassed: 'Passed',
            },
            table: {
                tabIssues: 'Issue Locations',
                tabCoverage: 'Check Coverage',
                sourceOfficial: 'Official Rules',
                sourceCustom: 'Custom Rules',
                sourceCustomEmpty: 'No custom rule matches yet',
                searchPlaceholder: 'Search claims, issues or statutes',
                columnIndex: '#',
                columnLocation: 'Location',
                columnIssue: 'Check result / Issue',
                columnStatute: 'Applicable statute / Rule basis',
                columnSuggestion: 'Suggestion',
                columnEvidence: 'Evidence',
                evidenceEmpty: '—',
                statusPending: 'Needs revision',
                statusApplied: 'Revised',
                statusIgnored: 'Ignored',
                statusPass: 'Passed',
                coverageColumnType: 'Rule type',
                coverageColumnRule: 'Rule checked',
                coverageColumnContent: 'Rule content',
                coverageColumnResult: 'Check result',
                coverageResultEmpty: '—',
                coverageResultFound: 'Issue found',
                ruleTypeOfficial: 'Official rule',
                ruleTypeCustom: 'Enterprise rule',
                itemUnit: 'items',
                columnPatentChapter: 'Patent Chapter',
                columnCheckRule: 'Check Rule',
                columnCheckResult: 'Check Result',
                columnErrorReason: 'Error Reason',
                editButton: 'Edit',
                adoptButton: 'Adopt Revision',
                locateButton: 'Locate Error',
                locationModalTitle: 'Error Location',
                locationModalContent: 'Location: {location}',
                locationModalClose: 'Close',
                locationModalRuleLabel: 'Check Rule',
                locationModalLocationLabel: 'Location',
                locationModalSuggestionLabel: 'Suggestion',
                locationModalBoundaryLabel: 'Applicable boundary',
                locationModalSourceTitle: 'Source Content',
                locationModalPositionUnresolved: 'Unable to determine error position',
                statusRequireModify: 'Requires revision',
                statusRequireConfirm: 'Requires manual confirmation',
                statusPendingVerification: 'Pending verification',
            },
            finalizing: {
                reportTitle: 'Patent Review Report',
                reportSubtitle: 'A Multi-Level Damping Buffer Device',
                conclusion: 'Overall conclusion',
                totalRules: 'Total rules',
                passCount: 'Pass',
                warningCount: 'Warning',
                errorCount: 'Error',
                criticalCount: 'Critical',
                conclusions: {
                    formal: 'Formal check conclusion',
                    art26_3: 'Article 26.3 conclusion',
                    art26_4: 'Article 26.4 conclusion',
                },
                riskMatrix: {
                    title: 'Substantive review risk distribution',
                    high: 'High risk',
                    medium: 'Medium risk',
                    low: 'Low risk',
                },
                conclusionValue: {
                    compliant: 'Compliant',
                    risky: 'Basically compliant with risk',
                    non_compliant: 'Possibly non-compliant',
                    insufficient: 'Insufficient material for a full determination',
                },
                dimensionConclusions: {
                    title: 'Dimension conclusions',
                    unresolved: 'Not determined',
                },
                reportMeta: {
                    office: 'Patent Office',
                    applicationType: 'Application Type',
                    invention: 'Invention',
                    reportDate: 'Report Date',
                    summaryTitle: 'Report Summary',
                    summaryDefault: 'Prioritize correcting definitive formal issues and verify the reachability of cited references; verify patent scope and disclosure basis; evaluate the impact of added limitations and re-review after modifications and material verification.',
                    checkModule: 'Check Module',
                    currentConclusion: 'Current Conclusion',
                    coverageScope: 'Coverage Scope',
                    formalCheck: 'Formal Check',
                    substantiveCheck: 'Substantive Check',
                },
                formalCheckDetail: {
                    title: 'Formal Issues Details',
                    ruleSource: 'Rule Source',
                    ruleCount: 'Rule Count',
                    failed: 'Failed',
                    needConfirm: 'Needs Confirmation',
                    passed: 'Passed',
                    pending: 'Pending',
                    systemRules: 'System Rules',
                    customRules: 'Custom Rules',
                    note1: 'The table below shows findings. Other rules remain in pending status; pending and unconfirmed items do not represent passing.',
                    note2: 'Source text should be marked for modifications or marked as "to-do" rather than directly corrected.',
                    location: 'Source Text & Location',
                    conclusion: 'Conclusion & Risk',
                    suggestion: 'Amendment Suggestion & Boundary',
                },
            },
            featureMapping: {
                figuresNone: 'This application contains no figures',
                figuresFailed: 'Figure recognition did not complete; this assessment did not incorporate figure content',
                figureNoLabel: 'Figure {no}',
                figureNoUnknown: 'Figure number not labeled',
                figureConfidenceMedium: 'Figure number inferred',
                figureConfidenceLow: 'Figure number undetermined',
                figureSignsLabel: 'Reference signs',
                figureNoSigns: 'No reference signs visible',
            },
            substantive: {
                filterHigh: 'High risk',
                filterMedium: 'Medium risk',
                filterLow: 'Low risk',
                filterAll: 'All',
                needsInventorConfirm: 'Needs inventor confirmation',
                boundaryLabel: 'Applicable boundary',
                summaryPattern: 'Found {count} substantive issues, review each one carefully',
                issuesLocations: 'Formal issue locations',
                title: 'Substantive Review',
                checkResultTitle: 'Check Result',
                issuesCount: 'Substantive issues',
                highRiskCount: 'High risk issues',
            },
            supplement: {
                title: 'Necessary supplementary materials',
                columns: {
                    content: 'Content to supplement',
                    reason: 'Reason',
                    targetStatute: 'Target statute',
                    suggestedLocation: 'Suggested location',
                },
                empty: 'No supplementary materials',
            },
            failed: {
                retryHint: 'The review task failed. Go back to the list to re-upload.',
            },
            reportLoadFailed: {
                message: 'Failed to load the review report, please retry',
                retry: 'Retry',
            },
            stepRunning: 'This step is running. Results will appear once it completes…',
            noStepSelected: 'Select a step to view its details',
        },
        customRuleDocuments: {
            delete: 'Delete',
            edit: 'Edit',
            deleteConfirm: 'Delete this?',
            confirmYes: 'Confirm',
            confirmNo: 'Cancel',
            empty: 'No rule documents yet',
            applicableScopeLabelText: 'Applicable Scope',
            sourceLabel: 'Rule Source',
            table: {
                name: 'Library Name',
                office: 'Region',
                field: 'Technical Field',
                rulesCount: 'Rules',
                updatedAt: 'Last Updated',
                actions: 'Actions',
                enabled: 'Enabled',
            },
            rulesEmpty: 'No rules were extracted from this document',
            rulesLoadFailed: 'Failed to load rule details, please retry',
            rulesCount: '{count} rules',
            status: {
                uploaded: 'Uploaded',
                parsing: 'Parsing',
                parsed: 'Parsed',
                parse_failed: 'Parse failed',
            },
            upload: {
                title: 'Upload Rule Document',
                addButton: 'Upload Rule Document',
                fileTitle: 'Upload rule document',
                fileHint: 'PDF, DOCX',
                chooseFile: 'Choose File',
                removeFile: 'Remove',
                confirm: 'Upload',
                uploading: 'Uploading…',
                nameLabel: 'Library Name',
                namePlaceholder: 'Defaults to file name if empty',
                patentOfficeLabel: 'Region',
                technicalFieldLabel: 'Technical Field',
            },
            technicalFieldOptions: {
                Common: 'Common',
                Mechanical: 'Mechanical',
                Electrical: 'Electrical',
                Chemical: 'Chemical',
            },
            loadFailed: 'Failed to load rule documents, please retry',
            uploadFailed: 'Failed to upload rule document, please retry',
            updateFailed: 'Failed to update, please retry',
            deleteSuccess: 'Deleted successfully',
            deleteFailed: 'Failed to delete, please retry',
            editDrawer: {
                title: 'Edit Rule Library',
                save: 'Save',
                saving: 'Saving…',
                backToList: 'Back to List',
            },
            detail: {
                loadFailed: 'Failed to load rule library, please retry',
            },
            import: 'Import File',
            importSuccess: 'File imported successfully, parsing rules…',
            importFailed: 'Failed to import file, please retry',
            parseCompleted: 'Rule parsing completed',
            parseTimeout: 'Rules are being parsed, please refresh later',
            parseFailed: 'Rule parsing failed',
            parseError: 'Unsupported file format',
            selectedLabel: 'Selected {count} rule libraries · {rules} rules',
        },
        customRule: {
            addRule: 'Add Rule',
            addFromTemplate: 'Add from Template',
            editRule: 'Edit Rule',
            editRuleDescription: 'Write check conditions in detail to ensure rules are executed correctly.',
            enabled: 'Enabled',
            allRules: 'All Rules',
            patentSection: 'Patent Section',
            patentSectionPlaceholder: 'Select patent section',
            patentSectionTitle: 'Title',
            patentSectionField: 'Technical Field',
            patentSectionBackground: 'Background',
            patentSectionSummary: 'Summary',
            patentSectionClaims: 'Claims',
            patentSectionSpecification: 'Specification and Drawings',
            patentSectionImplementation: 'Detailed Implementation',
            patentSectionAbstract: 'Abstract',
            patentSectionSpecificationOnly: 'Specification',
            patentSectionFullText: 'Full Text',
            problemDescription: 'Problem Description',
            problemDescriptionPlaceholder: 'Enter problem description',
            problemDescriptionTip: 'Writing tips: specify the check object and describe trigger conditions, avoid only writing "improper expression".',
            alertType: 'Alert Type',
            severityInfo: 'Info',
            severityWarning: 'Warning',
            severityError: 'Error',
            problemDescriptionRequired: 'Problem description is required',
            problemDescriptionMinLength: 'Problem description must be at least 10 characters',
            addRuleDialog: {
                title: 'Add Rule',
                subtitle: 'Add from a template or an existing file. Current rules are kept.',
                templateOption: 'Use a Rule Template',
                templateOptionHint: 'Start from a common checklist',
                importOption: 'Import Existing File',
                importOptionHint: 'Word / Excel / PDF / PPT',
                chooseTemplate: 'Choose a Rule Template',
                chooseTemplateHint: 'Pick a template close to your review standard, then edit rules one by one afterward.',
                templateCount: '{count} templates',
                ruleCount: '{count} rules',
                coveredSections: 'Covers:',
                importFileTitle: 'Upload Rule File',
                importFileHint: 'Word, Excel, PDF, PPT',
                chooseFile: 'Choose File',
                removeFile: 'Remove',
                confirm: 'Save',
                submitting: 'Adding…',
            },
        },
        customRuleLibraries: {
            custom: 'Custom Rules',
            title: 'Rule Library',
            newLibrary: '+ Add Library',
            total: '{count} rule libraries',
            previous: 'Previous',
            next: 'Next',
            selectPlaceholder: 'Please select',
            clearFilters: 'Clear Filters',
            searchPlaceholder: 'Search library name',
            gridView: 'Grid view',
            listView: 'List view',
            all: 'All',
            domains: {
                Common: 'Common',
                Mechanical: 'Mechanical',
                Electrical: 'Electrical',
                Chemical: 'Chemical',
            },
            patentOffice: 'Patent Office',
            system: 'System',
            systemLibraryName: '{office} System Rule Library',
            createDialogTitle: 'Add Rule Library',
            ruleNameLabel: 'Library Name',
            ruleNamePlaceholder: 'Enter a library name',
            domainLabel: 'Technical Field',
            create: 'Create',
            createSuccess: 'Rule library created',
            createFailed: 'Failed to create, please retry',
            editDialogTitle: 'Edit Rule Library',
            noRules: 'No custom rule libraries yet',
            noRulesDesc: 'Click "Add Library" to create your first rule library',
        },
        catalog: {
            offices: {
                CNIPA: 'CNIPA',
                EPO: 'EPO',
                USPTO: 'USPTO',
                PCT: 'PCT',
            },
            enabled: 'Enabled',
            loading: 'Loading...',
            error: 'Failed to load',
            retry: 'Retry',
            empty: 'No data',
            formalRules: 'Formal Rules',
            substantiveDimensions: 'Substantive Dimensions',
            executeCheck: 'Execute Check',
            aiRewrite: 'AI Rewrite',
            more: 'More',
            reference: 'Reference',
            executionPass: 'Check passed',
            executionTriggered: 'Issue found',
            suggestionLabel: 'Suggestion',
            visionUnsupported: 'This rule depends on figure analysis results and cannot be executed individually',
            noDocumentSelected: 'Please select a document first',
            executeCheckFailed: 'Failed to execute the check, please retry',
            table: {
                ruleId: 'Rule ID',
                category: 'Category',
                severity: 'Severity',
                keyPoint: 'Key Point',
                patentSection: 'Patent Section',
                guidelineSource: 'Guideline Source',
                dimensionId: 'Dimension ID',
                statute: 'Statute',
                issueType: 'Issue Type',
            },
        },
        errors: {
            createTaskFailed: 'Failed to create the review task, please retry',
            loadTaskFailed: 'Failed to load task status, please retry',
            loadReportFailed: 'Failed to load the review report, please retry',
            loadTasksFailed: 'Failed to load the task list, please retry',
            unsupportedOffice: 'This patent office is not currently supported',
            exportReportFailed: 'Failed to export the review report, please retry',
        },
    },
};
